<script setup>

</script>

<template>
<div class="terms" id="privacy">
  <div class="container">
    <div class="terms__wrapper">
      <h2>Privacy Policy</h2>
      <h3>1. Overview</h3>
      <p>Gold-Charge.com is a trading name of SOFTWAREERA LTD, a private limited company incorporated in the United Kingdom. SOFTWAREERA LTD is a Data Controller and complies with the UK General Data Protection Regulation (UK GDPR) and the Data Protection Act 2018.
        This Privacy Policy explains how Gold-Charge.com collects, uses, stores, discloses, and protects personal information. Gold-Charge.com recognises that lawful handling of personal data is essential to maintaining the trust of clients, merchants, partners, and stakeholders.
        For the purposes of this Policy, SOFTWAREERA LTD is referred to as “Gold-Charge.com”, “we”, “us”, or “our”.
      </p>
      <h3>2. Purpose</h3>
      <p>The purpose of this Policy is to ensure that all employees, contractors, suppliers, and third-party service providers working with Gold-Charge.com understand their responsibilities under the UK GDPR and comply with all legal and internal requirements when handling personal data.</p>
      <h3>3. Scope</h3>
      <p>This Policy applies to all personal data collected, stored, or processed by Gold-Charge.com in the course of providing technical payment gateway services. Personal data may include (but is not limited to):</p>
      <ul>
        <li>names;</li>
        <li>postal addresses;</li>
        <li>email addresses;</li>
        <li>phone numbers;</li>
        <li>merchant business information;</li>
        <li>IP addresses and device identifiers;</li>
        <li>any information that directly or indirectly identifies an individual.</li>
      </ul>
      <h4>This Policy applies to information obtained through the Website, merchant onboarding, support communications, API activity, and any related services.</h4>
      <h3>4. Lawful Basis for Processing</h3>
      <p>Gold-Charge.com processes personal data only when at least one lawful basis under UK GDPR applies, including:</p>
      <ul>
        <li>contract performance – to evaluate and onboard merchants, enable integrations, and provide services;</li>
        <li>legal obligations – compliance with AML/KYC, fraud prevention, tax, sanctions, and accounting laws;</li>
        <li>legitimate interests – security monitoring, prevention of fraud or abuse, service improvement;</li>
        <li>consent – where required by law, such as marketing communications.</li>
      </ul>
      <h3>5. How Personal Data is Used</h3>
      <p>Personal information may be processed to:</p>
      <ul>
        <li>evaluate merchant onboarding requests;</li>
        <li>provide customer support and technical assistance;</li>
        <li>ensure Website and API security;</li>
        <li>comply with financial, legal, regulatory, and fraud-prevention obligations;</li>
        <li>communicate important updates or required notices;</li>
        <li>Gold-Charge.com does not sell or rent personal data.</li>
      </ul>
      <h3>6. Data Sharing</h3>
      <p>Gold-Charge.com may share personal data only when legally required or necessary to deliver services, including with:</p>
      <ul>
        <li>acquiring banks and payment processors;</li>
        <li>fraud-prevention and identity-verification providers;</li>
        <li>regulatory, tax, or law enforcement bodies;</li>
        <li>authorised IT or infrastructure vendors.</li>
      </ul>
      <p>All third-party processors are bound by written agreements requiring compliance with data protection laws.</p>
      <h3>7. International Transfers</h3>
      <p>If data must be transferred outside the United Kingdom, appropriate safeguards will apply, such as:</p>
      <ul>
        <li>UK GDPR adequacy regulations;</li>
        <li>standard Contractual Clauses;</li>
        <li>vendor compliance certifications.</li>
      </ul>
      <h3>8. Data Retention</h3>
      <p>Personal data is retained only as long as necessary to:</p>
      <ul>
        <li>fulfil contractual or legal obligations;</li>
        <li>comply with AML, tax, and financial record-keeping laws;</li>
        <li>resolve disputes and protect legal claims.</li>
      </ul>
      <h4>After retention periods expire, data is securely deleted or anonymised.</h4>
      <h3>9. Security</h3>
      <p>Gold-Charge.com implements technical and organisational measures designed to protect personal data, including encryption, access controls, stored-data minimisation, secure hosting, and incident-response procedures. Data breaches are handled in accordance with UK GDPR, including notifications when legally required.</p>
      <h3>10. Individual Rights</h3>
      <p>Under UK GDPR, individuals have the right to:</p>
      <ul>
        <li>access their data;</li>
        <li>request correction or deletion;</li>
        <li>request restriction or objection to processing;</li>
        <li>data portability;</li>
        <li>withdraw consent (if processing is based on consent)</li>
        <li>lodge a complaint with the ICO</li>
      </ul>
      <h4>For questions or legal requests, you may contact us via email: <a href="mailto:info@gold-charge.com">info@gold-charge.com</a></h4>
    </div>
  </div>
</div>
</template>

<style scoped lang="scss">
h2{
  color: #46302E;
  font-family: "Libre Caslon Text", sans-serif;
  font-size: 48px;
  font-style: italic;
  font-weight: 500;
  line-height: normal;
  padding-block: 70px 20px;
}

h3{
  color: #46302E;
  text-align: justify;
  font-family: "Didact Gothic", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-top: 30px;
}

p, a, li{
  color: #46302E;
  font-family: "Didact Gothic", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

h4{
  color: #46302E;
  font-family: "Didact Gothic", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-top: 30px;
}

ul{
  padding-left: 50px;
}

.terms{
  padding-block: 50px;
  background-image: url("@images/back.png");
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;
}
</style>